<style scoped>
.sshi-select {
    color:#fff !important;
  background-color: #234A53;
  border: 1px solid #234A53;
  border-radius: 4rem !important;
}

.sshi-select .custom-select-caret {
  color: red;
}
</style>
<template>
  <div>
  <span class="mb-3" style="font-weight:500; color:#234A53 ;">Filter Data</span>
    <p class="w-100">
            <b-form-select class="sshi-select mb-2" v-model="wilayahSelected" :options="wilayahOptions"></b-form-select>
            <b-form-select  class="sshi-select mb-2" v-model="tahunSelected" :options="tahunOptions"></b-form-select>
            <b-button @click="simpan()" class="w-100" pill variant="outline-primary" size="sm">Simpan</b-button>
    </p>
  </div>
  </template>
  
  <script>
  export default {
    data(){
        return {
            wilayahSelected:null,
            wilayahOptions: [
                { value: null, text: 'Wilayah' },
                { value: '00', text: 'Indonesia' },
                { value: '11', text: 'Aceh' },
                { value: '12', text: 'Sumatera Utara' },
                { value: '13', text: 'Sumatera Barat' },
                { value: '14', text: 'Riau' },
                { value: '15', text: 'Jambi' },
                { value: '16', text: 'Sumatera Selatan' },
                { value: '17', text: 'Bengkulu' },
                { value: '18', text: 'Lampung' },
                { value: '19', text: 'Kep. Bangka Belitung' },
                { value: '21', text: 'Kepulauan Riau' },
                { value: '31', text: 'DKI Jakarta' },
                { value: '32', text: 'Jawa Barat' },
                { value: '33', text: 'Jawa Tengah' },
                { value: '34', text: 'DI Yogyakarta' },
                { value: '35', text: 'Jawa Timur' },
                { value: '36', text: 'Banten' },
                { value: '51', text: 'Bali' },
                { value: '52', text: 'Nusa Tenggara Barat' },
                { value: '53', text: 'Nusa Tenggara Timur' },
                { value: '61', text: 'Kalimantan Barat' },
                { value: '62', text: 'Kalimantan Tengah' },
                { value: '63', text: 'Kalimantan Selatan' },
                { value: '64', text: 'Kalimantan Timur' },
                { value: '65', text: 'Kalimantan Utara' },
                { value: '71', text: 'Sulawesi Utara' },
                { value: '72', text: 'Sulawesi Tengah' },
                { value: '73', text: 'Sulawesi Selatan' },
                { value: '74', text: 'Sulawesi Tenggara' },
                { value: '75', text: 'Gorontalo' },
                { value: '76', text: 'Sulawesi Barat' },
                { value: '81', text: 'Maluku' },
                { value: '82', text: 'Maluku Utara' },
                { value: '91', text: 'Papua Barat' },
                { value: '94', text: 'Papua' }
            ],
            tahunSelected:null,
            tahunOptions: [
                { value: null, text: 'Tahun' },
                { value: 2022, text: '2022' }
            ]
        }
    },
    watch:{
        wilayahSelected(){
            // this.sendDataToParent()
        },
        tahunSelected(){
            // this.sendDataToParent()
        }
    },
    mounted(){
      let getObject = localStorage.getItem('filter')
      if(getObject !== null){
        this.wilayahSelected = JSON.parse(getObject).kodeWilayah
        this.tahunSelected = JSON.parse(getObject).tahun
      }
    },
    methods: {
      simpan(){
        this.sendDataToParent()
      },
      sendDataToParent() {
        this.$emit('get-data', [this.wilayahSelected, this.tahunSelected]);
        let obj = {kodeWilayah: this.wilayahSelected, tahun: this.tahunSelected};
        
        localStorage.setItem('filter', JSON.stringify(obj));

        if(this.wilayahSelected=='00'){
          localStorage.removeItem('filter');
        }
        this.$router.go(0)
      }
    }
  }
  </script>
  